__turbopack_context__.v({
  "background__tealGradient": "AboutUsSplitHero-module__bzRPnq__background__tealGradient",
  "background__transparent": "AboutUsSplitHero-module__bzRPnq__background__transparent",
  "background__white": "AboutUsSplitHero-module__bzRPnq__background__white",
  "container": "AboutUsSplitHero-module__bzRPnq__container",
  "extendBackgroundBelow": "AboutUsSplitHero-module__bzRPnq__extendBackgroundBelow",
  "image": "AboutUsSplitHero-module__bzRPnq__image",
  "imageContainer": "AboutUsSplitHero-module__bzRPnq__imageContainer",
  "imageContainerAbove": "AboutUsSplitHero-module__bzRPnq__imageContainerAbove",
  "imageRight": "AboutUsSplitHero-module__bzRPnq__imageRight",
  "mobileHeroHeight__large": "AboutUsSplitHero-module__bzRPnq__mobileHeroHeight__large",
  "mobileHeroHeight__small": "AboutUsSplitHero-module__bzRPnq__mobileHeroHeight__small",
  "textContainer": "AboutUsSplitHero-module__bzRPnq__textContainer",
  "textContainerInner": "AboutUsSplitHero-module__bzRPnq__textContainerInner",
  "withReducedPadding": "AboutUsSplitHero-module__bzRPnq__withReducedPadding",
});
